export default __webpack_public_path__ + "static/media/Frictionless.cd75e455.svg";